import "./styles/Contact.css";
import { useState } from "react";
import SEO from "./SEO";

const ENDPOINT = "https://submit-form.com/TmyRjBgh7";
const EMPTY = { name: "", email: "", phone: "", zipcode: "", message: "" };

const FIELDS = [
    { name: "name", label: "Full Name", type: "text", autoComplete: "name", required: true },
    { name: "email", label: "Email", type: "email", autoComplete: "email", required: true },
    { name: "phone", label: "Phone", type: "tel", autoComplete: "tel", required: true },
    { name: "zipcode", label: "Zipcode", type: "text", autoComplete: "postal-code", inputMode: "numeric", pattern: "[0-9]{5}" },
];

export default function Contact() {
    const [form, setForm] = useState(EMPTY);
    const [status, setStatus] = useState(null); // null | "sending" | "ok" | "error"

    const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const submitForm = async (e) => {
        e.preventDefault();
        setStatus("sending");
        try {
            const res = await fetch(ENDPOINT, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            setForm(EMPTY);
            setStatus("ok");
        } catch {
            setStatus("error");
        }
    };

    return (
        <div>
            <SEO
                path="/contact"
                title="Contact AT Appliance Repair | Book a Repair (331) 600-4935"
                description="Call or send a message to schedule appliance repair. We reply within minutes during working hours."
            />

            <h1 className="contact-greeting">Get in Touch</h1>

            <div className="w-layout-grid cta-component contact-us">
                <div className="grid-container-2">
                    <h2 className="contact-text">Headquarters</h2>
                    <p>Plainfield, IL 60586</p>
                    <h2 className="contact-text">Contact Information</h2>
                    <p className="contact-info">
                        Please don’t hesitate to contact us about all of your appliance repair needs. We will be happy to schedule a convenient appointment for you and our experienced technician.
                    </p>
                    <p className="contact-info"><strong><a href="tel:+13316004935">(331) 600-4935</a></strong></p>
                    <p><a href="mailto:altantransit@gmail.com">altantransit@gmail.com</a></p>
                    <h2 className="contact-text">Working Hours</h2>
                    <p className="contact-info">Monday - Sunday<br />8:00am - 9:00pm</p>
                </div>

                <div className="enquiry-form-wrapper">
                    <h2>Talk to an Expert Today!</h2>
                    <p>Call <a href="tel:+13316004935"><strong>(331) 600-4935</strong></a> or fill out the form to request a call back. We will reach out in 5-7 min.</p>

                    <form onSubmit={submitForm} className="enquiry-form-wrapper">
                        {FIELDS.map((f) => (
                            <div key={f.name}>
                                <label htmlFor={f.name}>{f.label}</label>
                                <input
                                    id={f.name}
                                    className="input w-input"
                                    maxLength={100}
                                    value={form[f.name]}
                                    onChange={onChange}
                                    {...f}
                                />
                            </div>
                        ))}

                        <div>
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                className="input w-input"
                                maxLength={500}
                                value={form.message}
                                onChange={onChange}
                            />
                        </div>

                        <button type="submit" disabled={status === "sending"}>
                            {status === "sending" ? "Sending..." : "Submit"}
                        </button>

                        <p role="status" aria-live="polite">
                            {status === "ok" && "Thank you. We received your request and will call you shortly."}
                            {status === "error" && "Something went wrong. Please call (331) 600-4935."}
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}